import { DatePicker, Input, InputNumber, message, Select, Switch } from 'antd';
import { updateCooperator, createCooperator } from '@/api';
import { FormModal, UploadImage } from '@/components';
import { ergodicObj, toDateTime } from '@/utils/utils';
import { st_banner } from '@/utils/statetype';
import React, { useState } from 'react';

const { positionObj, typeObj } = st_banner;
function BannderEdit({ visible, data, onChange }) {
  console.log("data", data)
  const [datas, setDatas] = useState({});
  // setDatas(data)
  const handleSubmit = async params => {
    console.log("params:", params)
    if (!params) return onChange();
    const { status, ...props } = params;

    data.id
      ? await updateCooperator({
        body: {
          id: data.id,
          ...params,
          status: status ? 1 : 0
        },
      })
      : await createCooperator({
        body: {
          ...props,
          status: status ? 1 : 0
        },
      });
    message.success('操作成功');
    onChange(true);
  };

  const formData = [
    data?.id && {
      name: 'id',
      label: '编号',
      rules: [{ required: true, message: '请输入编号' }],
      render: <Input disabled placeholder="请输入编号" />,
    },
    {
      name: 'name',
      label: '名称',
      rules: [{ required: true, message: '请输入名称' }],
      render: <Input placeholder="请输入名称" />,
    },
    {
      name: 'image',
      label: 'logo',
      rules: [{ required: true, message: '请选择logo' }],
      render: <UploadImage model="single" callBackString />,
    },
    {
      name: 'status',
      label: '是否启用',
      rules: [{ required: false, message: '请输入展示排序' }],
      render: <Switch
        defaultChecked={data?.status === 1}
        checkedChildren='启用'
        unCheckedChildren='隐藏'
      // onChange={(check) => updateCooperatorOperate({ id: e.id, status: check ? 1 : 0 })}
      />,
    },

  ];

  return (
    <FormModal
      title="合作伙伴"
      visible={visible}
      formData={formData}
      initialValues={data}
      onChange={handleSubmit}
    />
  );
}

export default BannderEdit;
